var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAvatarDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_avatar_default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_avatar_default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10",
    fill: "#D5F9E6",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9996135,49.254386 C46.3477905,49.254386 43.387403,46.249981 43.387403,42.5438596 C43.387403,38.8377383 46.3477905,35.8333333 49.9996135,35.8333333 C53.6514365,35.8333333 56.611824,38.8377383 56.611824,42.5438596 C56.611824,46.249981 53.6514365,49.254386 49.9996135,49.254386 Z M35.85683,61.9671053 C36.9221305,55.2938596 42.8363855,51.4912281 49.9996135,51.4912281 C57.1628415,51.4912281 63.0770964,55.2938596 64.142397,61.9671053 C64.3260695,63.122807 63.4444414,64.1666667 62.2689374,64.1666667 L37.7302896,64.1666667 C36.59152,64.1666667 35.6731574,63.122807 35.85683,61.9671053 Z",
    id: "Combined-Shape",
    fill: "#27DE81",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAvatarDefault);
export default __webpack_public_path__ + "static/media/ic_avatar_default.4ad1254ff76b257d0c0759b1591e7e16.svg";
export { ForwardRef as ReactComponent };